module.exports = __webpack_public_path__ + "static/img/noCar.82def793.png";